import { isProductionEnv } from "../../../lib/currentEnvironment";
import { PopupMenuPositions } from "../PopupMenuPositions";

var isValidPosition = function isValidPosition(position) {
  return PopupMenuPositions.includes(position);
};

export var isValidPositions = function isValidPositions(positions) {
  return positions.every(function (item) {
    if (isProductionEnv) {
      return isValidPosition(item);
    } else {
      if (isValidPosition(item)) {
        return true;
      } else {
        throw new Error("Unxpected position \"" + item + "\"");
      }
    }
  });
};